/**
 * Cross-module System permission keys (visible for all company types).
 */
export const SYSTEM_PERMISSIONS = {
  /** Header payment / grace / suspension banner (tenant billing alerts). */
  viewBillingStatusBanner: 'can_view_billing_status_banner',
} as const;

export type SystemPermissionKey = keyof typeof SYSTEM_PERMISSIONS;
export type SystemPermissionValue = (typeof SYSTEM_PERMISSIONS)[SystemPermissionKey];
